import Products from '../Products';
import user from '../Users';

export const MODALS_BY_NAME = {
    products: Products,
    user
};
